var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGuacMoneyOff(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 54,
    height: 54,
    viewBox: "0 0 54 54",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_i_16370_1837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M26.7499 5.62849V2.27073C26.7499 1.63273 26.9654 1.09823 27.3964 0.667233C27.8269 0.236733 28.3614 0.0214844 28.9999 0.0214844C29.6384 0.0214844 30.1729 0.236733 30.6034 0.667233C31.0344 1.09823 31.2499 1.63273 31.2499 2.27073V5.53624C32.7884 5.75924 34.2154 6.28249 35.5309 7.10599C36.8459 7.92899 37.9554 8.96349 38.8594 10.2095C39.2554 10.7365 39.4159 11.3067 39.3409 11.9202C39.2659 12.5337 38.9652 13.0385 38.4387 13.4345C37.9117 13.8305 37.3414 13.991 36.7279 13.916C36.1144 13.841 35.6097 13.54 35.2137 13.013C34.5327 12.0285 33.6584 11.2507 32.5909 10.6797C31.5239 10.1087 30.3769 9.82323 29.1499 9.82323C28.4654 9.82323 27.7982 9.92699 27.1482 10.1345C26.4982 10.342 25.8847 10.6285 25.3077 10.994C24.7192 11.2865 24.1384 11.3307 23.5654 11.1267C22.9924 10.9227 22.5597 10.5265 22.2672 9.93799C21.9752 9.34999 21.9262 8.76923 22.1202 8.19573C22.3142 7.62273 22.7054 7.19023 23.2939 6.89823C23.8094 6.54423 24.3614 6.26923 24.9499 6.07323C25.5384 5.87673 26.1384 5.72849 26.7499 5.62849ZM50.1267 52.4517L38.5422 40.8672C37.7537 41.8287 36.6614 42.6287 35.2654 43.2672C33.8689 43.9057 32.5304 44.2557 31.2499 44.3172V47.675C31.2499 48.3135 31.0344 48.848 30.6034 49.2785C30.1729 49.7095 29.6384 49.925 28.9999 49.925C28.3614 49.925 27.8269 49.7095 27.3964 49.2785C26.9654 48.848 26.7499 48.3135 26.7499 47.675V44.1672C24.5499 43.6747 22.6874 42.7862 21.1624 41.5017C19.6374 40.2172 18.4039 38.5767 17.4619 36.5802C17.1769 35.9727 17.1259 35.3497 17.3089 34.7112C17.4914 34.0727 17.8864 33.6112 18.4939 33.3267C19.1134 33.0422 19.7299 33.021 20.3434 33.263C20.9569 33.5055 21.4212 33.9305 21.7362 34.538C22.4672 36.111 23.4894 37.415 24.8029 38.45C26.1164 39.4845 27.7154 40.0017 29.5999 40.0017C30.7694 40.0017 31.8299 39.7882 32.7814 39.3612C33.7334 38.9342 34.5692 38.3515 35.2887 37.613L1.54991 3.87498C1.13441 3.45948 0.921914 2.93723 0.912414 2.30823C0.902914 1.67973 1.11541 1.14823 1.54991 0.713733C1.98441 0.278733 2.51141 0.0612366 3.13091 0.0612366C3.74991 0.0612366 4.27691 0.278733 4.71191 0.713733L53.2879 49.2897C53.7034 49.7052 53.9159 50.2275 53.9254 50.8565C53.9354 51.4855 53.7229 52.0172 53.2879 52.4517C52.8534 52.8862 52.3267 53.1035 51.7077 53.1035C51.0882 53.1035 50.5612 52.8862 50.1267 52.4517Z",
    fill: "#838383"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_16370_1837",
    x: 0.912109,
    y: 0.0214844,
    width: 53.0137,
    height: 57.082,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_16370_1837"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGuacMoneyOff);
export default __webpack_public_path__ + "static/media/guac_money_off.5c6fdea0c61c886815559f02e56c330a.svg";
export { ForwardRef as ReactComponent };